import appConfig from "@/helpers/appConfig"

const firebaseApp = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID
}

const vapidKey = import.meta.env.VITE_FIREBASE_VAPID_KEY

// Local vite dev: always off. Deployed builds: VITE_FIREBASE_ANALYTICS_ENABLED in .env.{mode}
const analyticsCollectionEnabled = appConfig.isProductionBuild
  ? import.meta.env.VITE_FIREBASE_ANALYTICS_ENABLED === "true"
  : false

const firebaseConfig = { firebaseApp, vapidKey, analyticsCollectionEnabled }

export default firebaseConfig
